import { Paper, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import { ChooseNewPassword } from './01-ChooseNewPassword';
import { PasswordResetCancelled } from './04-PasswordResetCancelled';
import { InvalidToken } from './02-InvalidToken';
import { PasswordResetSuccess } from './03-PasswordResetSuccess';
import { useTranslation } from 'react-i18next';

export function PasswordResetStepper() {
  const { t } = useTranslation();
  const activeStep = useSelector((state) => state.GlobalReducer.currentPasswordResetStep);
  const steps = [<ChooseNewPassword />, <InvalidToken />, <PasswordResetSuccess />, <PasswordResetCancelled />];
  const stepTitles = ['choose_new_password', 'invalid_reset_link', 'password_reset_success_title', 'password_reset_cancelled_title'];

  return (
    <Paper sx={{ width: 400, padding: 5, margin: 'auto' }}>
      <Typography variant="h4" align="center" sx={{ marginBottom: 10 }} color="primary">
        {t(stepTitles[activeStep])}
      </Typography>
      {steps[activeStep]}
    </Paper>
  );
}
